import styled from "styled-components";
import { useState, useEffect } from "react";
import React from 'react'
import Header from "../Header";

const LoanCalculator = (props) => {

    const [state, setState] = useState({
        amount:0, 
        rate: 0, 
        time:0
    })
  

    const [results, setResult] = useState({
        resultedAmount:0,
        totalInterests:0,
        total:0
    })

    

    const handleChange = (e)=>{
    //     let newRate

    //    if(state.amount <= 14000){
    //         newRate= 30
    //    }
    //    else if(state.amount > 14000 && state.amount <=49000){
    //        newRate = 20
    //    }
    //    else{
    //        newRate = 15
    //    }
        setState({
            ...state,
            [e.target.name]: e.target.value,
            
        });
        
    }

    const handleSubmit = (e)=>{
        e.preventDefault();
        
        let newRate

       if(state.amount <= 14000){
            newRate= 7.5
       }
       else if(state.amount > 14000 && state.amount <=49000){
           newRate = 5
       }
       else{
           newRate = 3.75
       }

       setState({
           ...state,
           rate:newRate
       })

        const resultedAmount = parseFloat(newRate/100 * state.amount);
        const totalInterests = parseFloat(resultedAmount * state.time);
        const total = totalInterests + parseFloat(state.amount);

        setResult({
            resultedAmount,
            totalInterests,
            total
        })

        console.log(results);
    }
    useEffect(()=>{
        window.scrollTo(0,0)
      },[])
     
    return (

        <>
           <Header/>
            <Banner>
                <div className="banner__container">
                    <div className="banner__content">
                        <h2>Loan Calculator</h2>
                    </div>
                    <div className="banner__background"></div>
                </div>
            </Banner>

            <Container>
                <h2>Simple Loan Calculator</h2>
                <p>The simple Loan Calculator will determine your estimated payments for loan amounts, interest rates and terms</p>

                <form onSubmit ={handleSubmit}>
                    <div>
                        <label htmlFor="amount">Loan Amount</label>
                        <input type="number" name="amount" id="amount" onChange = {handleChange}/>
                    </div>
                    <div>
                        <label htmlFor="rate">Interest Rate</label>
                        <input type="number" name="rate" id="rate" onChange = {handleChange} value={state.rate}/>
                    </div>
                    <div>
                        <label htmlFor="time">Number of weeks</label>
                        <input type="number" name="time" id="time" onChange = {handleChange}/>
                    </div>
                    <FormButton onClick = {handleSubmit}>Calculate</FormButton>
                    <FormButton2 href="/">Apply</FormButton2>
                </form>
                <Results>
                    <h3>Calculated Results</h3>
                    <div className="results__section">
                        <div className="result__loan">
                            <span className="span__amount">N{results.resultedAmount}</span>
                            <span className="span__caption">Weekly Payments</span>
                        </div>
                        <div className="result__interest">
                            <span className="span__amount">N{results.totalInterests}</span>
                            <span className="span__caption">Total Interests</span>
                        </div>
                        <div className="result__amount">
                            <span className="span__amount">N{results.total}</span>
                            <span className="span__caption">Total Amount</span>
                        </div>
                    </div>
                </Results>
            </Container> 
        </>
    )
}



const Container = styled.div`
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    


    form{
       border: 1px solid rgba(96, 96, 96, 0.4);
       padding: 20px;

       input{
            border: 1px solid rgba(96, 96, 96, 0.4);
       }

       label{
           color: rgb(96, 96, 96);
       }
       
       div{
           display: flex;
           justify-content: space-between;
           margin-bottom: 20px;
       }
    }

    @media(min-width: 768px){
        max-width: 60%;
        margin: auto;
        text-align: center;
    }
`


const FormButton = styled.a`
    width: 100%;
    color: rgb(231, 60, 62);
    border: 1px solid rgb(231, 60, 62);
    display: block;
    text-align: center;
    padding: 5px 0;

    :hover{
        background: rgb(231, 60, 62);
        color: white;
        transition: 0.5s ease;
    }
`
const FormButton2 = styled.a`
    width: 100%;
    color: white;
    border: 1px solid rgb(231, 60, 62);
    background: rgb(231, 60, 62);
    display: block;
    text-align: center;
    padding: 5px 0;
    margin-top: 20px;

    :hover{
        background: white;
        color: rgb(231, 60, 62);
        transition: 0.5s ease;
    }
`
const Results = styled.div`

    div.results__section{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        div{
            color: #fff;
            display: flex;
            flex-direction: column;
            padding: 10px 15px;

            span.span__amount{
                font-size: 22px;
                font-weight: 600;
            }
        }
        div.result__loan{
            background: rgb(231, 60, 62);
        }
        div.result__amount{
            background: blue;
        }
        div.result__interest{
            background: grey;
        }
    }
`
const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;
        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url("https://images.pexels.com/photos/164527/pexels-photo-164527.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500");
        background-size: cover;
        background-position-x: center;
        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;
    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
        text-align: center;
    }
    
`
export default LoanCalculator
